import moment from 'moment';
import { OnHandReportTransactionDetailsEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { OrderTransactionTypesEnum } from 'Common/Constants/Enumeration/CommonEnum';

const DATE = moment();

export const BASE_URL = '/onhandreport';

export const INITIAL_VALUES = {
  [OnHandReportTransactionDetailsEnum.ShowAllDates]: true,
  [OnHandReportTransactionDetailsEnum.FromDt]: DATE.subtract(1, 'month').format(
    DATE_FORMAT_FOR_UI
  ),
  [OnHandReportTransactionDetailsEnum.ToDt]: DATE.add(2, 'month').format(
    DATE_FORMAT_FOR_UI
  ),
  Types: [
    OrderTransactionTypesEnum.Adjustment,
    OrderTransactionTypesEnum.Order,
    OrderTransactionTypesEnum.Physical,
    OrderTransactionTypesEnum.Receipt,
    OrderTransactionTypesEnum.Transfer,
    OrderTransactionTypesEnum.Usage,
  ],
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/helper/transactionDetails.js